import React from "react";
import { Flex, Box, Text } from "theme-ui";
import PropTypes from "prop-types";
import { Button, DisplayIcon } from '../atoms';
import { colors, typography } from '../../styles/theme';

const styles = {
  container: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "1.5rem",
    backgroundColor: colors.white,
    borderRadius: "20px",
    border: `1px solid ${colors.neutral200}`,
    maxWidth: "19rem",
    mt: ['3rem', '3rem', '3rem', 0]
  },
  iconStyles: {
    marginBottom: "1.5rem",
  },
  titleStyles: {
    ...typography.h7,
    color: colors.black,
  },
  subtitleStyles: {
    ...typography.textMd400,
    marginBottom: "1.5rem",
    color: colors.black,
  },
};

const ResourceDownloadCard = ({
  iconName,
  theme,
  title,
  subtitle,
  buttonLabel,
  onBtnClick,
  btnWidth,
  btnVariant,
  customStyles,
}) => {
  const { container, titleStyles, subtitleStyles } = styles;
  return (
    <Flex sx={{ gap: "1.5rem", ...container, ...customStyles }}>
      {iconName && <DisplayIcon iconName={iconName} theme={theme} />}

      <Box>
        {title && (
          <Box
            sx={{
              ...titleStyles,
              my: subtitle ? "0.313rem" : "1.5rem",
            }}
          >
            {title}
          </Box>
        )}
        {subtitle && <Text sx={subtitleStyles}>{subtitle}</Text>}
      </Box>
      {buttonLabel && (
        <Button
          size="large"
          variant={btnVariant}
          btnWidth={btnWidth}
          onClick={onBtnClick}
        >
          {buttonLabel}
        </Button>
      )}
    </Flex>
  );
};

ResourceDownloadCard.defaultProps = {
  iconName: null,
  iconColor: null,
  title: null,
  subtitle: null,
  buttonLabel: null,
  onBtnClick: () => {},
  customStyles: {},
};

ResourceDownloadCard.propTypes = {
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onBtnClick: PropTypes.func,
  customStyles: PropTypes.object,
  buttonLabel: PropTypes.string,
  btnWidth: PropTypes.oneOf(["default", "full"]),
  btnVariant: PropTypes.oneOf(["filled", "outlined"]),
};

export default ResourceDownloadCard;
